const ARTIST_ID_MAP = {
    "eva lau": "eva_lau",
    "cici osias": "cici_osias",
    "sahana vathsa": "sahana_vathsa",
    "damian gong": "damian_gong",
    "anna mcclain": "anna_mcclain_kyker",
    "kyker": "anna_mcclain_kyker",
    "jiyou kang": "jiyou_kang",
    "dway lunkad": "dway_lunkad",
    "elysse abraham": "elysse_abraham",
    "chloe chen": "chloe_chen",
    "ashley": "ashley_kamal",
    "kamal": "ashley_kamal",
    "em kapp": "em_kapp",
    "hannah bashkow": "hannah_bashkow",
    "miraal zafar": "miraal_zafar",
    "ruby howell": "ruby_howell",
    "will": "will_beakley",
    "beakley": "will_beakley",
    "nicole tani": "nicole_tani",
    "urvi": "urvi_binjrajka",
    "binjrajka": "urvi_binjrajka",
    "ritwik": "ritwik_chakravarty",
    "chakravarty": "ritwik_chakravarty",
    "charlotte": "charlotte_whatley",
    "whatley": "charlotte_whatley",
    "fenner weeks": "fenner_weeks",
    "ernestine": "ernestine_klecz",
    "klecz": "ernestine_klecz",
    "naz abechu": "naz_abechu",
    "geist topping": "geist_topping",
    "ethan": "ethan_jiang",
    "jiang": "ethan_jiang",
    "william hsu": "william_hsu",
    "livia miller": "livia_miller",
    "fernanda": "fernanda_machinena",
    "machinena": "fernanda_machinena",
    "karina": "karina_garbarini",
    "garbarini": "karina_garbarini",
    "jeffrey": "jeffrey_mccready",
    "mccready": "jeffrey_mccready",
    "julia": "julia_mccauley",
    "mccauley": "julia_mccauley",
    "jennora": "jennora",
    "8theroach": "8theroach",
    "jaiyn": "jaiyn",
    "teniola": "teniola",
    "sanjana rao": "sanjana_rao",
    "stephanie": "stephanie_ling",
    "ling": "stephanie_ling",
};

export default ARTIST_ID_MAP;